import React, { useState, useEffect, useContext } from 'react'
import { object, bool, string, array } from 'prop-types'

import { CARTRIDGES } from 'utils/constants'
import { trackEvent } from 'utils/tracking'

import CheckoutContext from 'contexts/Checkout'
import NativeAuthContext from 'components/NativeAuth'
import Section from 'components/Section'
import Wrapper from 'components/Wrapper'
import CollectionHeader from 'components/buy/CollectionHeader'
import SubscriptionInfoBox from 'components/CartridgePage/SubscriptionInfoBox'
import CartridgeList from 'components/buy/CartridgeList'
import CartridgeThumbnail from 'components/buy/CartridgeThumbnail'
import MultipackThumbnail from 'components/buy/MultipackThumbnail'
import Filters, { Filter } from 'components/buy/Filters'
import PodsFilter from 'components/buy/PodsFilter'
import PodsFilterMobile from 'components/buy/PodsFilterMobile'

const epodFilters = [
  {
    value: '',
    label: 'All'
  },
  {
    value: 'New',
    label: 'New'
  },
  {
    value: 'Bestsellers',
    label: 'Bestsellers'
  },
  {
    value: 'Zeronic',
    label: 'Zero Nicotine Options'
  },
  {
    value: 'TobaccoMints',
    label: 'Tobacco & Mints'
  }
]

const Refills = ({
  titleOverride,
  descriptionOverride,
  data,
  deviceHandles,
  subscriptionOnly,
  excludedProductHandles
}) => {
  const { products } = useContext(CheckoutContext)
  const { province } = useContext(NativeAuthContext)

  const [filter, setFilter] = useState(deviceHandles[0])
  const [cartridges, setCartridges] = useState([])
  const [filterValue, setFilterValue] = useState('')

  useEffect(() => {
    if (!window.dataObject) return
    window.dataObject.time = Date()
    trackEvent({
      name: 'screenLoad',
      time: Date(),
      page: window.location.pathname + `#${filter}`,
      url: window.location.href
    })
  }, [])

  const collection = data.cartridgeCollection.nodes[0]

  useEffect(() => {
    const upToDateCartridges = data.cartridgeCollection.nodes.reduce(
      (acc, collection) => [
        ...acc,
        ...collection.products
          .filter(p => {
            if (excludedProductHandles) return !excludedProductHandles.includes(p.handle)
            else return true
          })
          .map(p => ({
            ...p,
            collection
          }))
      ],
      []
    )

    upToDateCartridges.forEach(c => {
      c.variants.forEach(v => {
        v.quantity = 0
      })
    })

    setCartridges(upToDateCartridges)
  }, [])

  const handleChange = e => {
    setFilterValue(e.target.value)
  }

  return (
    <>
      <CollectionHeader
        heading={titleOverride || collection.title}
        description={descriptionOverride || collection.descriptionHtml}
      />

      <Section flushTop>
        <Wrapper>
          <SubscriptionInfoBox />
        </Wrapper>
      </Section>

      {filter === 'vype-epod-vpro-cartridges' && (
        <Section flushTop>
          <Wrapper>
            {/* Splits into desktop and mobile because BAT wanted the native dropdown on mobile but a custom dropdown on desktop */}

            {/* Desktop */}
            <div className="u-hide-medium-down">
              <PodsFilter
                value={filterValue}
                options={epodFilters}
                onChange={setFilterValue}
                results={
                  cartridges.filter(
                    c => c.collection.handle === filter && (filterValue === '' || c.tags.includes(filterValue))
                  ).length
                }
              />
            </div>

            {/* Mobile */}
            <div className="u-hide-medium-up">
              <PodsFilterMobile
                value={filterValue}
                options={epodFilters}
                onChange={handleChange}
                results={
                  cartridges.filter(
                    c => c.collection.handle === filter && (filterValue === '' || c.tags.includes(filterValue))
                  ).length
                }
              />
            </div>
          </Wrapper>
        </Section>
      )}

      {deviceHandles.length > 1 && (
        <Filters>
          {deviceHandles.map(handle => (
            <Filter
              key={handle}
              selected={handle === filter}
              title={CARTRIDGES[handle].title}
              onClick={() => {
                setFilter(handle)
              }}
            />
          ))}
        </Filters>
      )}
      <Section flushTop>
        <Wrapper>
          <CartridgeList>
            <MultipackThumbnail
              name="5 Pack Bundle"
              description={
                <span>
                  Select 5 packs of your choice and <strong>save 23%</strong>
                </span>
              }
              slug="5-pack"
              price="$50.00"
              link="/buy-online/multipack-5/"
              hidden={filter !== 'vype-epod-vpro-cartridges' || subscriptionOnly}
            />
            <MultipackThumbnail
              name="3 Pack Bundle"
              description={
                <span>
                  Select 3 packs of your choice and <strong>save 15%</strong>
                </span>
              }
              slug="3-pack"
              price="$33.00"
              link="/buy-online/multipack-3/"
              hidden={filter !== 'vype-epod-vpro-cartridges' || subscriptionOnly}
            />
            {cartridges.map((product, i) => {
              const fetchedProduct = products.find(p => product.id.includes(p.shopifyGid))

              return (
                <CartridgeThumbnail
                  hidden={
                    product.collection.handle !== filter ||
                    (filterValue !== '' && !product.tags.includes(filterValue)) ||
                    (fetchedProduct && !fetchedProduct.availableProvinces.includes(province))
                  }
                  collectionHandle={product.collection.handle}
                  key={i}
                  product={product}
                  subscriptionOnly={subscriptionOnly}
                />
              )
            })}
          </CartridgeList>
        </Wrapper>
      </Section>
    </>
  )
}

Refills.propTypes = {
  data: object,
  titleOverride: string,
  descriptionOverride: string,
  subscriptionOnly: bool,
  deviceHandles: array.isRequired,
  excludedProductHandles: array
}

export default Refills
